/** @format */

import { call, put, takeLatest } from 'redux-saga/effects';
import { getNotificationsService } from 'services/apiService';
import * as actionTypes from 'stateContainer/action-types';
import { push } from 'connected-react-router';

function* workerSaga({ payload }) {
  try {
    const response = yield call(getNotificationsService, payload);
    if (response.data.status == 'success') {
      yield put({
        type: actionTypes.NOTIFICATIONS_SUCCESS,
        payload: response.data.data
      });
    } else {
      throw new Error('Login failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.NOTIFICATIONS_ERROR, error });

    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/'));
    }
  }
}

export function* notificationSaga() {
  yield takeLatest(actionTypes.NOTIFICATIONS_REQUESTED, workerSaga);
}
